import { render, staticRenderFns } from "./medications.vue?vue&type=template&id=a63455b6&scoped=true&"
import script from "./medications.vue?vue&type=script&lang=js&"
export * from "./medications.vue?vue&type=script&lang=js&"
import style0 from "./medications.vue?vue&type=style&index=0&id=a63455b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63455b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VContainer,VIcon,VProgressCircular,VRow,VSnackbar})
